// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { Checkbox, Col, Divider, Form, Row } from "antd";
import { getModuleAccessAPI, getModulesAPI, getRoleModuleAccessAPI } from "services/system_setup/role_access";
import { UserAccessContext } from "context/userAccess";

const CheckboxGroup = Checkbox.Group;

const AddRoleAccess = (props) => {
    const { userAccess } = useContext(UserAccessContext);
    const updateRight = userAccess['systemSetup'].update;

    const roleDataProps = ( props.roleData === undefined ? [] : props.roleData )
    const [modules, setModules] = useState([]);
    const [moduleAccess, setModuleAccess] = useState([]);
    const [moduleAccessListDisabled, setModuleAccessListDisabled] = useState({});
    const [accessTypes, setAccessTypes] = useState([]);
    const [roleModuleAccess, setRoleModuleAccess] = useState([]);
    
    // console.log('updateRight =>', updateRight);

    const getList = async () => {
        const resModules = await getModulesAPI();
        const resModuleAccess = await getModuleAccessAPI();
        const resRoleModule = await getRoleModuleAccessAPI(roleDataProps.role_id);
        let targetDisabledSubModules= {};
        let modules = [];

        // console.log('resMOdules =>', resModules);
        // console.log('resMOdulesAccess =>', resModuleAccess);
        // console.log('resRoleModule =>', resRoleModule);

        resModuleAccess.map( rma => {
            if(rma.access_type_code !== 'vw'){
                targetDisabledSubModules[`${rma.module_access_code}`] = false;
            }
        });

        if(props.action === 'UPDATE'){
            resRoleModule.map( rma => {
                if(rma.access_type_code === 'vw'){
                    modules.push(rma);
                }
            });
        }else{
            resModules.map( rm => {
                modules.push(rm);
            });
        }

        modules = modules.sort((a, b)=> a.sort - b.sort);

        setModules(modules);
        setModuleAccess(resModuleAccess);
        setRoleModuleAccess(resRoleModule);
        setModuleAccessListDisabled(targetDisabledSubModules);

        if(props.action === 'UPDATE'){
            const filterSelectedRoles = resRoleModule.filter((i) => i.active_role_access === true)
            const selectedRoles = filterSelectedRoles.map(({module_access_code}) => module_access_code)
            setAccessTypes(selectedRoles)
        }
    }

    useEffect(()=> {
        getList();
    }, []);

    useEffect(()=> {
        props.roleAccessValues(accessTypes)
    }, [accessTypes]);

        // console.log('modules =>', modules);


        const isSubModuleDisabled = (targetModule, subMod)=>{
            const module_access_code = `${targetModule.module_code}_vw`;
            let additionalProp = {};

            // console.log('subMod =>', subMod);

            if(['agnt_cncl','cust_cncl','sys_cncl','usr_cncl','lkp_cncl', 'rpt_cncl', 'rpt_edt', 'rpt_crt', 'rpt_edt', 'rpt_ovr', 'rpt_prnt', 'rpt_pst'].includes(subMod.module_access_code) ){
                return { disabled: true}                
            }

            if(props.action === 'UPDATE'){

                if(props.form.getFieldValue(module_access_code) === true){
                    additionalProp = {disabled : !(props.action === 'UPDATE' ? subMod.active_module_access : false ) }
                }else{
                    additionalProp = {disabled: true}
                }

            }else{

                if(props.form.getFieldValue(module_access_code) === true){
                    additionalProp = {disabled : !(props.action !== 'UPDATE' ? subMod.is_active : false) }
                }else{
                    additionalProp = {disabled: true}
                }
            }
            
            return additionalProp;
        };

    const DisplayedModules = modules.map( md =>{
        let subMods;
        
        if(props.action === 'UPDATE'){
            subMods = roleModuleAccess.filter( ma => ma.module_code === md.module_code && ma.access_type_code !== 'vw');
        }else{
            subMods = moduleAccess.filter( ma => ma.module_code === md.module_code && ma.access_type_code !== 'vw');
        }

        const DisplayedSubModules = subMods.map( sm =>
            <Form.Item name={sm.module_access_code} valuePropName="checked" initialValue={sm.active_role_access}>
                <Checkbox onChange={(x)=>{handleSubModuleChange(x, sm )}} 
                {...isSubModuleDisabled(md, sm)}
                >{sm.access_type_name}</Checkbox>
            </Form.Item>
        );
        const handleSubModuleChange = (x, sm) =>{
            let targetModule = {};
            if(x.target.checked){
                targetModule[`${sm.module_code}_vw`] = true;
                props.form.setFieldsValue(targetModule);
            };
        }

        const handleModuleChange = (x) =>{
            let targetAccessRoles = {};
            
            if(!x.target.checked){
                subMods.map( sm => {
                    targetAccessRoles[sm.module_access_code] = false;
                });
            }
            props.roleAccessValues(targetAccessRoles);
            props.form.setFieldsValue(targetAccessRoles);
        }
        
        return(
            <Row>
                <Divider />
                <Col span={12}>
                    <Form.Item name={`${md.module_code}_vw`} valuePropName="checked" initialValue={props.action === 'UPDATE' ? md.active_role_access : false }>
                        <Checkbox onChange={(x)=>{handleModuleChange(x)}}>{md.module_name}</Checkbox>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    {DisplayedSubModules}
                </Col>
            </Row>
        )
    });
    
    return (
        <div>
            {DisplayedModules}
        </div>
    )
};

export default AddRoleAccess;